import React, {lazy, memo, Suspense, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ConfigProvider} from 'antd';
import {darkTheme, lightTheme} from 'configs/ThemeConfig';
import {resources} from 'lang';
import useBodyClass from 'utils/hooks/useBodyClass';
import Routes from 'routes';
import LoadingComponent from "../views/app-views/components/LoadingComponent";
import {getCookie} from "../services/CookieService";
import {AUTH_TOKEN} from "../constants/AuthConstant";
import {setToken, signOutSuccess} from "../store/slices/authSlice";
import refreshJwtToken from "../serviceHandler/RefreshTokenServiceHandler";
import store from "../store";

const AppLayout = lazy(() => import('./AppLayout'));
const AuthLayout = lazy(() => import('./AuthLayout'));

const Layouts = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);

    const token = useSelector(
        state => state.auth.token === 'undefined' || state.auth.token === undefined ? null : state.auth.token
    );

    const blankLayout = useSelector(state => state.theme.blankLayout);
    const Layout = token && !blankLayout ? AppLayout : AuthLayout;

    const locale = useSelector(state => state.theme.locale);
    const direction = useSelector(state => state.theme.direction);
    const currentTheme = useSelector(state => state.theme.currentTheme);
    const currentAppLocale = resources[locale];

    useBodyClass(`dir-${direction}`);

    const themeConfig = currentTheme === 'light' ? {...lightTheme} : {...darkTheme};

    useEffect(() => {
        const fetchTokenAndRefresh = async () => {
            await refreshJwtToken();

            const tokenNew = getCookie(AUTH_TOKEN);
            if (tokenNew && tokenNew !== token) {
                dispatch(setToken(tokenNew));
            }
            setIsLoading(false);
        };
        if(localStorage.getItem('userData')) {
            fetchTokenAndRefresh();
        } else {
            setIsLoading(false);
            store.dispatch(signOutSuccess())
        }
    }, [dispatch, token]);

    if (isLoading) {
        return <LoadingComponent />;
    }

    return (
        <ConfigProvider theme={themeConfig} direction={direction} locale={currentAppLocale.antd}>
            <Suspense fallback={<LoadingComponent/>}>
                <Layout>
                    <Routes/>
                </Layout>
            </Suspense>
        </ConfigProvider>
    );
}

export default memo(Layouts);
